import React, { useEffect, useState } from "react";
import "../CSS/TopbarTenagaKesehatan.css";
import { FaBell, FaUserCircle } from "react-icons/fa";

function TopbarDetail() {
  const [username, setUsername] = useState("User");

  useEffect(() => {
    const admin = JSON.parse(localStorage.getItem("admin"));

    if (admin && admin.username_admin) {
      setUsername(admin.username_admin);
    }
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-left">
        <h2 className="page-title">Peta Risiko TBC</h2>
      </div>

      <div className="user-info">
        <FaBell className="icon" />

        <div className="user-name">
          {/* username dari hasil login */}
          <p className="name">{username}</p>

          {/* role tidak berubah */}
          <p className="role">Admin</p>
        </div>

        <FaUserCircle className="profile-icon" />
      </div>
    </div>
  );
}

export default TopbarDetail;
